import { send } from "./GoogleAnalyticsClient";
import { GA_TEXT_CONSTS as TEXT_CONSTS } from "../../../constants";
import { FunnelEvent, GAFunnelEvent } from "../../../models";

const createFunnelEvent: (fe: FunnelEvent) => GAFunnelEvent = ({
    step,
    label,
    name,
    isUIEvent = false,
    uiEventName = "",
    feedback = "",
}) => ({
    event: TEXT_CONSTS.EVENTS.FUNNEL,
    funnel_step: step,
    funnel_label: label,
    funnel_name: name,
    funnel_is_ui_event: isUIEvent,
    funnel_ui_event_name: uiEventName,
    funnel_feedback: feedback,
});

export const trackFunnelEvent: (fe: FunnelEvent) => Promise<unknown> = ({
    step,
    label,
    name,
    isUIEvent = false,
    uiEventName,
    feedback,
}) => send(createFunnelEvent({ step, label, name, isUIEvent, uiEventName, feedback }));
